import React from 'react';

type Props = {
  className?: string;
  svgClassName?: string;
  fill?: string;
};

const WisedocLogo: React.FC<Props> = ({
  className,
  svgClassName,
  fill = '#B89FDB',
}) => (
  <div
    className={
      className || 'flex h-[36px] w-[36px] items-center justify-center'
    }
    aria-hidden="true"
  >
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassName}
    >
      <path
        d="M13.2879 15.0863H15.8963C16.3685 15.0863 16.7823 14.7522 16.9059 14.2707L20.2139 1.3943C20.3945 0.691725 19.8936 0 19.2044 0H16.5959C16.1237 0 15.7101 0.334117 15.5864 0.815551L12.2783 13.692C12.0978 14.3946 12.5987 15.0863 13.2879 15.0863Z"
        fill={fill}
      />
      <path
        d="M4.66495 14.2707L7.973 1.3943C8.15356 0.691725 7.65266 0 6.96347 0H4.35498C3.88278 0 3.46914 0.334117 3.34545 0.815551L0.0370851 13.692C-0.143366 14.3946 0.357427 15.0863 1.04661 15.0863H3.65542C4.12762 15.0863 4.54126 14.7522 4.66495 14.2707Z"
        fill={fill}
      />
      <path
        d="M9.03015 7.83694H11.6386C12.1108 7.83694 12.5245 7.50282 12.6482 7.0215L14.094 1.3943C14.2746 0.691725 13.7737 0 13.0845 0H10.4758C10.0036 0 9.58982 0.334117 9.46624 0.815551L8.02052 6.44275C7.83996 7.14532 8.34086 7.83705 9.03005 7.83705L9.03015 7.83694Z"
        fill={fill}
      />
      <path
        d="M10.7131 8.91406H8.10459C7.63239 8.91406 7.21875 9.24818 7.09506 9.72961L3.78712 22.6061C3.60656 23.3086 4.10746 24.0003 4.79665 24.0003H7.40513C7.87734 24.0003 8.29108 23.6662 8.41466 23.1848L11.7227 10.3084C11.9033 9.60579 11.4024 8.91406 10.7132 8.91406H10.7131Z"
        fill={fill}
      />
      <path
        d="M22.9537 8.91406H20.3449C19.8727 8.91406 19.4591 9.24818 19.3354 9.72961L16.0273 22.6061C15.8469 23.3086 16.3478 24.0003 17.0368 24.0003H19.6453C20.1175 24.0003 20.5313 23.6662 20.6549 23.1848L23.9631 10.3084C24.1437 9.60579 23.6428 8.91406 22.9536 8.91406H22.9537Z"
        fill={fill}
      />
      <path
        d="M14.9731 16.1642H12.3647C11.8925 16.1642 11.4787 16.4983 11.3551 16.9796L9.90919 22.6068C9.72863 23.3094 10.2295 24.0011 10.9187 24.0011H13.5275C13.9997 24.0011 14.4134 23.667 14.5371 23.1856L15.9828 17.5584C16.1632 16.8558 15.6624 16.1641 14.9732 16.1641L14.9731 16.1642Z"
        fill={fill}
      />
    </svg>
  </div>
);

WisedocLogo.defaultProps = {
  className: undefined,
  svgClassName: undefined,
  fill: '#B89FDB',
};

export default WisedocLogo;
